import axios from './axios';
import { UserWithProductInfoDto } from './types';

export const getUserMineSDK = async () => {
  const { data } = await axios.get<UserWithProductInfoDto>('/api/User/MineSDK');

  return data;
};

export const getUserProductAccess = async (userId: string, product: string) => {
  const { data } = await axios.post('/api/Subscription/GetUserProductAccess', {
    userId,
    product,
  });
  return data.productAccess;
};

export interface IntercomAuthResponse {
  intercomUserJWT: string;
  expiresAt: string;
}

export const getIntercomAuth = async (): Promise<IntercomAuthResponse> => {
  const { data } = await axios.get<IntercomAuthResponse>('/api/User/GetIntercomAuth');

  return data;
};
